import DeviceStatusIcon from './DeviceStatusIcon';

export default DeviceStatusIcon;
